import React from 'react';
import { formatDate } from './StocktakeUtils';

const ChevronRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const BoxIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
);

/**
 * Mobile card view for a single stocktake row
 */
const StocktakeTableRowMobile = ({ stocktake, navigateToStocktakeDetail }) => {
  const statusClass = stocktake.status === 1 ? 'completed' : 'active';
  const statusLabel = stocktake.status === 1 ? 'Complete' : 'In Progress';

  return (
    <div
      className="forms-mobile-card"
      onClick={() => navigateToStocktakeDetail(stocktake._id)}
    >
      <div className="forms-mobile-card-left">
        <div className="stocktake-icon">
          <BoxIcon />
        </div>
        <div className="forms-mobile-card-info">
          <span className="forms-mobile-card-name">
            {formatDate(stocktake.date)}
          </span>
          <span className="forms-mobile-card-meta">
            {stocktake.user?.name || 'N/A'}
            <span className="forms-mobile-card-dot"> · </span>
            {'\u00A3'}{(stocktake.value || 0).toFixed(2)}
          </span>
        </div>
      </div>
      <div className="forms-mobile-card-right">
        <span className={`forms-status ${statusClass}`}>
          {statusLabel}
        </span>
        <ChevronRightIcon />
      </div>
    </div>
  );
};

export default StocktakeTableRowMobile;
